<template>
    <div class="my-charts">
        <div class="child-chart-container" :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
const colorList = [
    '#95b0e7',
    '#ca8a89',
    '#91e090',
    '#e6c993',
    '#ffef62',
    '#72b362',
    '#0195ff',
    '#f0a959',
    '#5470c6',
    '#91cc75',
    '#ee6666',
    '#fc8452',
    '#9a60b4',
    '#ea7ccc',
];
function renderItem(params, api) {
    var categoryIndex = api.value(0);
    var start = api.coord([api.value(1), categoryIndex]);
    var end = api.coord([api.value(2), categoryIndex]);
    var height = api.size([0, 1])[1] * 0.6;
    var rectShape = echarts.graphic.clipRectByRect(
      {
          x: start[0],
          y: start[1] - height / 2,
          width: end[0] - start[0],
          height: height
      },
      {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
      }
    );
    return (
      rectShape && {
          type: 'rect',
          transition: ['shape'],
          shape: rectShape,
          style: api.style()
      }
    );
}

export default {
    name: "interactiveEvaDataEchart",
    props: {
        id:{
            type: String,
            default:"interactiveEvaDataEchart"
        },
        title:{
            type: String,
            default:"时序图"
        },
        videoUrl:{
            type: String,
            default:""
        },
        dataList:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        dataList(newValue,oldValue){
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            sequenceChart: null,
            chartList:[],
            chartOption:{
                tooltip: {
                    formatter: function (params) {
                        return params.marker + params.name + ': ' + params.value[3].toFixed(1) + '分钟';
                    }
                },
                title: {
                    text: this.title,
                    left: 'center'
                },
                grid:{
                    left:'18%',
                    right:'3%',
                    bottom:'7%'
                },
                xAxis: {
                    scale: false,
                    axisLine: { show: true },
                    axisLabel: {
                        formatter: function (val) {
                            return val + '分钟';
                        }
                    },
                },
                yAxis: {
                    data: []
                },
                series: [
                    {
                        type: 'custom',
                        renderItem: renderItem,
                        itemStyle: {
                            opacity: 0.8
                        },
                        encode: {
                            x: [1, 2],
                            y: 0
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        formattedNumber(number) {
            return number.toFixed(1);
        },
        init() {
            this.chartList = this.dataList;
            const categoryList = [];
            const chartDataList = [];
            if (this.chartList&&this.chartList.length>0){
                this.chartList.forEach((item,index )=> {
                    categoryList.push(item.event_name)
                    var eventData = JSON.parse(item.event_data);
                    if (eventData&&eventData.length>0){
                        eventData.forEach(i => {
                            chartDataList.push({
                                name: item.event_name,
                                value: [index, i[0], i[1], i[1]-i[0]],
                                itemStyle: {
                                    normal: {
                                        color: colorList[index]
                                    }
                                }
                            })
                        })
                    }
                })
            }
            this.chartOption.yAxis.data = categoryList;
            this.chartOption.series[0].data = chartDataList;
            this.sequenceChart = echarts.init(document.getElementById(this.id));
            this.sequenceChart.setOption(this.chartOption);
            this.sequenceChart.on('click', (params) => {
                // 根据需要处理点击事件，例如显示提示框、跳转等
                let currentTime = params.value[1].toFixed(1);
                let timeSecond = Math.floor(60 * currentTime)
                this.$emit('view-course-video',timeSecond);
            });
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    height: auto;
}
.child-chart-container{
    width: 100%;
    height: 400px;
}
</style>